import { useCallback, useState } from 'react';
import { isNaN } from 'lodash';

import { useTranslation } from '@lyearn/i18n';
import { Box, FilterActions, NumberInput } from '@lyearn/ui';
import { FilterOperators } from '@/components/Filter/types';
import { FilterBodyProps } from '@/components/FilterNew/components/Body/types';
import FilterHeader from '@/components/FilterNew/components/Header';

const NumberFilter = ({
  uiConfig,
  onChange,
  headerProps,
  initialSelectedOptions,
  initialSelectedOperator,
}: FilterBodyProps) => {
  // add operators support @iamsaumya
  const { t } = useTranslation();
  const { showActionButtons = true } = uiConfig ?? {};
  const [selectedOperator, setSelectedOperator] = useState<FilterOperators | undefined>(
    initialSelectedOperator,
  );
  const [inputVal, setInputVal] = useState(() => {
    return typeof initialSelectedOptions !== 'number' ? 0 : initialSelectedOptions;
  });

  const onClear = useCallback(() => {
    onChange([
      {
        value: '',
        label: '',
      },
    ]);
  }, [onChange]);

  const onSave = useCallback(() => {
    onChange([
      {
        value: isNaN(inputVal) ? '' : inputVal.toString(),
        label: '',
      },
    ]);
  }, [inputVal, onChange]);

  return (
    <Box className="w-[28rem] xs:w-full">
      <FilterHeader
        {...headerProps}
        operatorsActions={{
          methods: {
            setSelectedOperator,
          },
          selectedOperator,
        }}
      />
      <NumberInput
        autoFocus
        canBeEmpty
        className="w-full border-none"
        min={0}
        placeholder={t('Tags:AddNumberHere')}
        size="medium"
        value={inputVal}
        onChange={setInputVal}
      />
      {showActionButtons ? <FilterActions onClear={onClear} onSave={onSave} /> : null}
    </Box>
  );
};

export default NumberFilter;
